import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
import { ReleaseNotesTab } from './ReleaseNotesTab';
import { ProductManualsTab } from './ProductManualsTab';
import { AbbreviationsTab } from './AbbreviationsTab';
const TabPanel = (props) => {
    const { children, value, activeValue } = props;
    // Mount lazily on first visit, then keep mounted to prevent re-fetching on tab switch
    const [hasEverBeenActive, setHasEverBeenActive] = useState(value === activeValue);
    if (value === activeValue && !hasEverBeenActive) {
        setHasEverBeenActive(true);
    }
    return (_jsx(Box, { role: "tabpanel", hidden: value !== activeValue, id: `help-tabpanel-${value}`, "aria-labelledby": `help-tab-${value}`, children: hasEverBeenActive && children }));
};
export const HelpSupportView = () => {
    const { t } = useTranslation('help');
    const [activeTab, setActiveTab] = useState('release-notes');
    const [unreadCount, setUnreadCount] = useState(0);
    const handleUnreadCountChange = useCallback((count) => setUnreadCount(count), []);
    const handleTabChange = (_event, newValue) => {
        setActiveTab(newValue);
    };
    return (_jsx(Box, { sx: {
            width: '100%',
            minHeight: '100vh',
            backgroundColor: colorTokens.gray50,
            p: 2,
        }, children: _jsxs(Box, { sx: { maxWidth: 1280, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 1.5 }, children: [_jsxs(Tabs, { value: activeTab, onChange: handleTabChange, "aria-label": "help and support tabs", sx: {
                        borderBottom: `1px solid ${colorTokens.gray200}`,
                        minHeight: 40,
                        '& .MuiTabs-indicator': {
                            backgroundColor: colorTokens.magenta,
                            height: 2,
                        },
                    }, children: [_jsx(Tab, { value: "release-notes", label: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.75 }, children: [t('tabs.releaseNotes'), unreadCount > 0 && (_jsx(Box, { component: "span", sx: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '50%',
                                            bgcolor: colorTokens.magenta,
                                            color: 'white',
                                            fontSize: '0.5rem',
                                            fontWeight: 700,
                                            minWidth: 16,
                                            height: 16,
                                            px: '4px',
                                            lineHeight: 1,
                                        }, children: unreadCount }))] }), id: "help-tab-release-notes", "aria-controls": "help-tabpanel-release-notes", sx: {
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '0.75rem',
                                minHeight: 40,
                                py: 1.25,
                                px: 2.5,
                                overflow: 'visible',
                                color: colorTokens.gray600,
                                '&.Mui-selected': {
                                    color: colorTokens.primary,
                                },
                            } }), _jsx(Tab, { value: "product-manuals", label: t('tabs.productManuals'), id: "help-tab-product-manuals", "aria-controls": "help-tabpanel-product-manuals", sx: {
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '0.75rem',
                                minHeight: 40,
                                py: 1.25,
                                px: 2.5,
                                color: colorTokens.gray600,
                                '&.Mui-selected': {
                                    color: colorTokens.primary,
                                },
                            } }), _jsx(Tab, { value: "abbreviations", label: t('tabs.abbreviations'), id: "help-tab-abbreviations", "aria-controls": "help-tabpanel-abbreviations", sx: {
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '0.75rem',
                                minHeight: 40,
                                py: 1.25,
                                px: 2.5,
                                color: colorTokens.gray600,
                                '&.Mui-selected': {
                                    color: colorTokens.primary,
                                },
                            } })] }), _jsx(TabPanel, { value: "release-notes", activeValue: activeTab, children: _jsx(ReleaseNotesTab, { initialPlatform: "WEB", onUnreadCountChange: handleUnreadCountChange }) }), _jsx(TabPanel, { value: "product-manuals", activeValue: activeTab, children: _jsx(ProductManualsTab, {}) }), _jsx(TabPanel, { value: "abbreviations", activeValue: activeTab, children: _jsx(AbbreviationsTab, {}) })] }) }));
};
